export default __webpack_public_path__ + "static/strategic-consulting-472a4d493c3e4541716bc5e2753d231f.svg";